import { render } from "./Insurances.vue?vue&type=template&id=4bc20508&scoped=true"
import script from "./Insurances.vue?vue&type=script&lang=js"
export * from "./Insurances.vue?vue&type=script&lang=js"

import "./Insurances.vue?vue&type=style&index=0&id=4bc20508&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc20508"]])

export default __exports__